import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition, {
  ParamValues,
} from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import EventsTable from '@/components/careConsole/EventsTable.vue';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { isEmpty } from '@/utils/misc';
import { ImportantMessageLevel } from '@/models/Charts/chartsData';
import { dateRangeToDateStrings } from '@/utils/dates';
import moment from 'moment';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import { LayoutSlot } from '@/views/dashboard/layout-grid';
import { SortOrder } from '@/models/enums/SortOrder';
import { computed, ref } from 'vue';
import { useRoute } from '@/composables/router';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Events',
  props: {
    dateRange: null,
    dateGrouping: null,
    eventTypes: null,
    eventModules: null,
    eventCodes: null,
    deviceId: null
  },
  setup(__props: any) {

const props = __props as {
  dateRange: [Date, Date];
  dateGrouping: FilterTimeAxisSpanEnum;
  eventTypes: ImportantMessageLevel[];
  eventModules: string[];
  eventCodes: string[];
  deviceId: string;
};



const route = useRoute();

const gridLayout: LayoutSlot[] = [
  { column: 0, row: 0, width: 6, height: 4 },
  { column: 6, row: 0, width: 6, height: 4 },
  { column: 0, row: 4, width: 12, height: 4 },
];

const eventsTablePage = ref(1);
const eventsTableSortField = ref<string | null>(null);
const eventsTableSortOrder = ref<string | null>(null);

function onEventsTablePageChanged(page: number) {
  eventsTablePage.value = page;
}

function onEventsTableSortChanged(sortField: string, sortOrder: SortOrder) {
  eventsTableSortField.value = sortField;
  eventsTableSortOrder.value = sortOrder;
}

const timelineWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareEventsTimeline,
      props.deviceId,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.dateGrouping,
      undefined,
      paramValues.value,
    ),
);

const moduleTypeWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareEventsByModule,
      props.deviceId,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      // This isn't used by the chart, but by the modal opened on double-click
      props.dateGrouping,
      undefined,
      paramValues.value,
    ),
);

const eventsTableWidgetDefinition = computed<WidgetDefinition>(() => {
  const customerIdDh = route.value.params.tenantIdDh
    ? +route.value.params.tenantIdDh
    : +route.value.params.customerIdDh;

  return new WidgetDefinition(
    WidgetEnum.EventsTable,
    props.deviceId,
    dateRangeString.value,
    [],
    undefined,
    props.dateGrouping,
    undefined,
    {
      customerIdDh,
      modules: props.eventModules,
      eventTypes: props.eventTypes,
      eventCodes: props.eventCodes,
      page: eventsTablePage.value,
      sortField: eventsTableSortField.value,
      sortOrder: eventsTableSortOrder.value,
    },
  )
    .hideTitle()
    .hideInfo();
});

const paramValues = computed<ParamValues | undefined>(() =>
  isEmpty(props.eventTypes) &&
  isEmpty(props.eventModules) &&
  isEmpty(props.eventCodes)
    ? undefined
    : {
        eventTypes: props.eventTypes,
        eventModules: props.eventModules,
        eventCodes: props.eventCodes,
      },
);

const dateRangeString = computed<[string, string]>(() => [
  moment(props.dateRange[0]).startOf('day').toISOString(),
  moment(props.dateRange[1]).endOf('day').toISOString(),
]);

return { __sfc: true,props, route, gridLayout, eventsTablePage, eventsTableSortField, eventsTableSortOrder, onEventsTablePageChanged, onEventsTableSortChanged, timelineWidgetDefinition, moduleTypeWidgetDefinition, eventsTableWidgetDefinition, paramValues, dateRangeString, WidgetContainer, EventsTable, LayoutGrid }
}

})